export class TextToFind {
    text: string;
    language: string;
    option: string;

    constructor(text: string, language: string, option: string) {
        this.text = text;
        this.language = language;
        this.option = option;
    }
}
